export default __webpack_public_path__ + "static/media/hust.4cb1cd50.png";